/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: JRA4OayO7Ias

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicTextarea.module.css"; // plasmic-import: JRA4OayO7Ias/css

createPlasmicElementProxy;

export type PlasmicTextarea__VariantMembers = {
  size: "small" | "medium" | "large";
  invalid: "invalid";
  disabled: "disabled";
};
export type PlasmicTextarea__VariantsArgs = {
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  invalid?: SingleBooleanChoiceArg<"invalid">;
  disabled?: SingleBooleanChoiceArg<"disabled">;
};
type VariantPropType = keyof PlasmicTextarea__VariantsArgs;
export const PlasmicTextarea__VariantProps = new Array<VariantPropType>(
  "size",
  "invalid",
  "disabled"
);

export type PlasmicTextarea__ArgsType = {
  value?: string;
  onValueChange?: (val: string) => void;
  placeholder?: string;
  onBlur?: () => void;
  ariaLabel?: string;
  ariaLabelledby?: string;
  name?: string;
};
type ArgPropType = keyof PlasmicTextarea__ArgsType;
export const PlasmicTextarea__ArgProps = new Array<ArgPropType>(
  "value",
  "onValueChange",
  "placeholder",
  "onBlur",
  "ariaLabel",
  "ariaLabelledby",
  "name"
);

export type PlasmicTextarea__OverridesType = {
  textarea?: Flex__<"textarea">;
};

export interface DefaultTextareaProps {
  value?: string;
  onValueChange?: (val: string) => void;
  placeholder?: string;
  onBlur?: () => void;
  ariaLabel?: string;
  ariaLabelledby?: string;
  name?: string;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  invalid?: SingleBooleanChoiceArg<"invalid">;
  disabled?: SingleBooleanChoiceArg<"disabled">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTextarea__RenderFunc(props: {
  variants: PlasmicTextarea__VariantsArgs;
  args: PlasmicTextarea__ArgsType;
  overrides: PlasmicTextarea__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          placeholder: ``
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "textarea.value",
        type: "writable",
        variableType: "text",

        valueProp: "value",
        onChangeProp: "onValueChange"
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.size
      },
      {
        path: "invalid",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.invalid
      },
      {
        path: "disabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.disabled
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <textarea
      data-plasmic-name={"textarea"}
      data-plasmic-override={overrides.textarea}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      aria-label={args.ariaLabel}
      aria-labelledby={args.ariaLabelledby}
      className={classNames(
        projectcss.all,
        projectcss.textarea,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.textarea,
        {
          [sty.textareadisabled]: hasVariant($state, "disabled", "disabled"),
          [sty.textareainvalid]: hasVariant($state, "invalid", "invalid"),
          [sty.textareasize_large]: hasVariant($state, "size", "large"),
          [sty.textareasize_medium]: hasVariant($state, "size", "medium"),
          [sty.textareasize_small]: hasVariant($state, "size", "small")
        }
      )}
      disabled={hasVariant($state, "disabled", "disabled") ? true : undefined}
      name={args.name}
      onBlur={async event => {
        const $steps = {};

        $steps["runOnBlur"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onBlur"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnBlur"] != null &&
          typeof $steps["runOnBlur"] === "object" &&
          typeof $steps["runOnBlur"].then === "function"
        ) {
          $steps["runOnBlur"] = await $steps["runOnBlur"];
        }
      }}
      onChange={async (...eventArgs: any) => {
        (e => {
          generateStateOnChangeProp($state, ["textarea", "value"])(
            e.target.value
          );
        }).apply(null, eventArgs);
      }}
      placeholder={args.placeholder}
      ref={ref => {
        $refs["textarea"] = ref;
      }}
      style={(() => {
        try {
          return {
            resize: "none"
          };
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      value={generateStateValueProp($state, ["textarea", "value"]) ?? ""}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  textarea: ["textarea"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  textarea: "textarea";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTextarea__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTextarea__VariantsArgs;
    args?: PlasmicTextarea__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTextarea__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTextarea__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTextarea__ArgProps,
          internalVariantPropNames: PlasmicTextarea__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTextarea__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "textarea") {
    func.displayName = "PlasmicTextarea";
  } else {
    func.displayName = `PlasmicTextarea.${nodeName}`;
  }
  return func;
}

export const PlasmicTextarea = Object.assign(
  // Top-level PlasmicTextarea renders the root element
  makeNodeComponent("textarea"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicTextarea
    internalVariantProps: PlasmicTextarea__VariantProps,
    internalArgProps: PlasmicTextarea__ArgProps
  }
);

export default PlasmicTextarea;
/* prettier-ignore-end */
